<template>
    <div class="background" :style="{'background': 'url(' + theImage + ')'}">
        <div class="transbox">
            <div class="transboxContent">
                <h2>{{ $t('clothing.Header') }}</h2>
                <h3>{{ $t('clothing.GeneralHeader') }}</h3>
                {{ $t('clothing.GeneralText1') }}
                <br />
                <br />
                {{ $t('clothing.GeneralText2') }}
                <br />
                <br />
                {{ $t('clothing.GeneralText3') }}
                <br />
                <br />
                {{ $t('clothing.GeneralText4') }}
                <br />
                <br />
                {{ $t('clothing.GeneralText5') }}
            </div>
        </div>
        <div id="image_holder" class="imageHolder">
            <div id="gridClothing">
                <kendo-datasource ref="datasourceClothing"
                                  :transport-read-url="url"
                                  :transport-read-data-type="'jsonp'">
                </kendo-datasource>
                <kendo-grid :data-source-ref="'datasourceClothing'"
                            ref="grid"
                            :toolbar="['pdf']"
                            :mobile="true"
                            :pdf-all-pages="true"
                            :pdf-avoid-links="true"
                            :pdf-paper-size="'A4'"
                            :pdf-margin="{ top: '2cm', left: '1cm', right: '1cm', bottom: '1cm' }"
                            :pdf-landscape="true"
                            :pdf-repeat-headers="true"
                            :pdf-file-name="$t('clothing.Header')"
                            :pdf-title="$t('clothing.Header')"
                            :pdf-scale="0.8">
                    <kendo-grid-column :field="'Graduierung'"
                                       :title="$t('clothing.GridColumnHeaderGraduation')"
                                       :minResizableWidth="120">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'Prim'"
                                       :title="$t('clothing.GridColumnHeaderImage')"
                                       :template=itemTemplate
                                       :minResizableWidth="120">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'Farbe'"
                                       :title="$t('clothing.GridColumnHeaderColor')"
                                       :minResizableWidth="120">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'Beschreibung'"
                                       :title="$t('clothing.GridColumnHeaderDescription')"
                                       :minResizableWidth="300">
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </div>
        <div class="transbox">
            <div class="transboxContent">
                <h3>{{ $t('clothing.TopAndPantsHeader') }}</h3>
                {{ $t('clothing.TopAndPantsText') }}
                <h3>{{ $t('clothing.BeltAndGraduationHeader') }}</h3>
                {{ $t('clothing.BeltAndGraduationText1') }}
                <br />
                <br />
                {{ $t('clothing.BeltAndGraduationText2') }}
                <br />
                <br />
                <br />
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import $ from 'jquery';
    import { EventBus } from '@/classes/eventBus.js';
    import '@progress/kendo-ui';
    import '@progress/kendo-theme-default/dist/all.css';
    import kendo from '@progress/kendo-ui';
    import { Grid, GridColumn } from '@progress/kendo-grid-vue-wrapper';
    import { KendoDataSource } from '@progress/kendo-datasource-vue-wrapper';
    import config from "@/appdata/config.json";

    export default {
        components: {
            'kendo-grid': Grid,
            'kendo-grid-column': GridColumn,
            'kendo-datasource': KendoDataSource
        },
        props: {
            linkItem: String,
            myText: String,
            url: String
        },
        data: function () {
            return {
                theImage: '',
                schemaModelFields: {
                    Graduierung: { validation: { required: true } },
                    Prim: { validation: { required: true } },
                    Farbe: { validation: { required: true } },
                    Beschreibung: { validation: { required: false } },
                }
            }
        },
        computed: {
        },
        mounted() {
            window.$ = kendo.jQuery;
            EventBus.$on('backgroundImageChange', image => {
                this.theImage = image;
            });
            const grid = this.$refs.grid.kendoWidget();
            $.each(grid.columns, function (index, column) {
                grid.resizeColumn(column, column.minResizableWidth);
            });
        },
        created() {
            this.url = config[0].ServiceUrl + config[0].ServiceUrlPort + "/Kleidung"
        },
        methods: {
            initGrid() {
                let language = this.$i18n.locale;
                if (language === "en") {
                    kendo.ui.Grid.fn.options.messages.pdf = "Export to PDF";
                } else {
                    kendo.ui.Grid.fn.options.messages.pdf = "Exportieren als PDF";
                }
            },
            itemTemplate(data) {
                let imageToLoad = data.Prim;
                var itemTemplate = kendo.template(
                        `<img src="` +
                        require("../images/belts/" + imageToLoad + ".gif") +
                        `" alt="#: Prim # image" />`
                    );
                    return itemTemplate(data);
                }
        }
    }
</script>

<style scoped>
    @import '../css/main.css';
</style>